module.exports = __webpack_public_path__ + "img/orders-icon.b128240b.svg";